import { useState } from 'react';
import "./style.scss";


const PasswordResetRequest = () => {
    const [email, setEmail] = useState('');
    const [feedback, setFeedback] = useState('');

    const handleResetRequest = async () => {
        // Send a POST request to your backend to handle the reset logic
        try {
            const response = await fetch('https://www.calmestcrypto.com/password-reset-request', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });

            if (response.status === 200) {
                setFeedback('Please check your email for reset instructions');
            } else {
                const data = await response.json ();
                console.log (data);
                setFeedback (data.message);
            }




            // if (response.status !== 200) {
            //     throw new Error('Error requesting password reset');
            // }

        } catch (err) {
            setFeedback('Error: ' + err.message);
            console.error (err.message);
        }
    };

    return (
        <div className="password-reset-container">
            <h2>Reset Password</h2>
            <input 
                type="email" 
                placeholder="Enter your email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleResetRequest}>Send Reset Link</button>
            {feedback && <p>{feedback}</p>}
        </div>
    );
};

export default PasswordResetRequest;
